import { css } from "@obby/components";

export const styles = {
  imageBulletPoints: css({
    width: "100%",
    display: "flex",
    flexWrap: "wrap"
  }),
  point: css({
    display: "flex",
    width: "100%",

    "&:last-child": {
      marginBottom: "0"
    },

    variants: {
      size: {
        small: {
          marginBottom: "20px"
        },
        large: {
          marginBottom: "25px"
        }
      },
      position: {
        center: {
          alignItems: "center"
        },
        start: {
          alignItems: "flex-start"
        }
      }
    }
  }),
  pointImage: css({
    marginRight: "12px"
  }),
  pointIcon: css({
    marginRight: "12px",

    g: {
      stroke: "$gray"
    },
    path: {
      stroke: "$gray"
    }
  }),
  pointTextWrap: css({
    display: "flex",
    flexWrap: "wrap"
  }),
  pointTitle: css({
    fontFamily: "$foundersGrotesk",
    fontSize: "$lParagraph",
    fontWeight: "600",
    lineHeight: "1",
    marginBottom: "5px",
    width: "100%"
  }),
  pointText: css({
    fontFamily: "$foundersGrotesk",
    fontSize: "$mParagraph",
    lineHeight: "$mParagraphLh",
    width: "100%"
  })
};
